import React from 'react';
import store from '../store/Store';

import Navigation from '../components/navigation/Navigation'
import Register from '../components/register/Register'

import { Redirect } from "react-router-dom";

import './registerView.scss';

type registerState = {
	article: any;
	navigation: any;
}

type registerProps = {
	history: any;
	article: any;
	navigation: any;
}

class RegisterView extends React.Component<registerState, registerProps> {

	constructor(props) {
		super(props)

		this.state = {
			article: props.article,
			navigation: props.navigation,
			history: props.history
		}
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				article: store.getState().article,
				navigation: store.getState().navigation
			})
		})
	}

	render() {
		let {
			history,
			article,
			navigation
		} = this.state

	  return (
	    <div className="RegisterView">
	    	
	    	{
	    		store.getState().login.loggedIn ? (
	    			<Redirect to='/editor' />
	    		) : store.getState().route.currentRoute === '/login' ? (
	    			<Redirect to='/login' />
	    		) : <Register history={ history } />
	    	}

	    </div>
	  )
	}
}

export default RegisterView;